import { IApiSuccessWrapper, IExportStatus } from '$/types'
import { apiSlice } from '.'

export const jobsApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    // NOTE: Do not use RTKQ for file download. Use fetch/axios instead.
    // getJobResult: build.query<Blob, string>({
    //   query: id => `/jobs/${id}`
    // }),
    // ! deprecated - use mutation method instead
    getJobStatus: build.query<IExportStatus, string>({
      query: (id) => `/jobs/${id}/status`,
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IExportStatus
      }
    }),
    getLatestJobStatus: build.mutation<IExportStatus, string>({
      query: (id) => ({
        url: `/jobs/${id}/status`,
        method: 'GET'
      }),
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IExportStatus
      }
    })
  })
})

export const { useGetJobStatusQuery, useGetLatestJobStatusMutation } = jobsApi
